import { GeneralSettings } from ".";

// Backend PermsSecureItem ACTION_* constants mirrored here for front-end usage.
export enum ActionPermission {
    ACTION_NON_INDEXED_SEARCH = "System.Non-indexed search",
    ACTION_OVERRIDE_GRID_CONFIGURATIONS = "System.Update grid configurations",
    ACTION_VIEW_FIELD_INFO = "System.View F4 field information",
    ACTION_DEL_COMMENT_NOT_OWN = "System.Delete comment if not owner",
    ACTION_CURRENCY_SELECTOR_UPDATE = "System.Currency selector update",
    ACTION_CURRENCY_EXCHANGE_SELECTOR_UPDATE = "System.Currency exchange selector update",
    ACTION_OVERRIDE_ATTACHMENT_SIZE_MAX = "System.Override attachment size maximum",
    ACTION_BANK_ACCOUNT = "Bank account.bank_account.cash_account_glid",
    ACTION_BANK_RECONCILIATION = "Bank reconciliation.bank_account.cash_account_glid",
    ACTION_BILLING_COMMENTS = "Billing.Billing Comments",
    ACTION_PRINT_POST_INVOICE = "AR.Print and Post Invoices",
    ACTION_UPDATE_BILLED_ORDER = "Dispatch.Update orders after transferred to invoicing",
    ACTION_QUICK_DISPATCH = "Dispatch.Quick dispatch",
    ACTION_DELIVERY_FORMAT = "Dispatch.Select delivery receipt template",
    ACTION_SPLIT_DELIVERED_MOVE = "Dispatch.Y-Split delivered moves",
    ACTION_UPDATE_MOVE_AFTER_SETTLED = "Dispatch.Update move after settled",
    ACTION_UPDATE_DEL_ORDER = "Dispatch.Update orders after delivery",
    ACTION_UPDATE_DEL_MOVES = "Dispatch.Update movements after delivery",
    ACTION_OVERRIDE_WIRE_LIMITS = "Dispatch.Override wire limits",
    ACTION_UPDATE_MOVEMENT_UNLOCK_OVERRIDE = "Brokerage.Movement unlock override",
    ACTION_UPDATE_MAX_PAY_OVERRIDE = "Brokerage.Max pay override",
    ACTION_UPDATE_TARGET_PAY_OVERRIDE = "Brokerage.Target pay override",
    ACTION_UPDATE_CARRIER_DISPATCH_OVERRIDE = "Brokerage.Carrier dispatch override",
    ACTION_OVERRIDE_COST_MARKUP = "Brokerage.Override markup of cost-based rates",
    ACTION_WATERFALL_PROGRESS_OVERRIDE = "Brokerage.Waterfall progress override",
    ACTION_PRINT_EXPORT_TO_EXCEL = "Print.Listing export to Excel/Copy to clipboard",
    ACTION_PRINT_SAVE_TO_FILE = "Print.Save to file",
    ACTION_PRINT_EMAIL = "Print.Email",
    ACTION_PRINT_FAX = "Print.Fax",
    ACTION_TRAILER_WASH_MAX_OVERRIDE = "Dispatch.Trailer Wash Max Override",
    ACTION_BROKERAGE_STATUS_WORKFLOW_OVERRIDE = "Brokerage.Brokerage status workflow override",
    ACTION_ADD_ORDERHIST_AFTER_BILL = "Dispatch.Add order history after transferred to invoicing",
    ACTION_UPDATE_ORDERHIST_AFTER_BILL = "Dispatch.Update order history after transferred to invoicing",
    ACTION_SHOW_NONZMITTED_PREASSIGNMENTS = "Dispatch.Show Driver Non-zmitted Preassignments",
    ACTION_FORCE_CLEAR_STOPS = "LTL.Force clear stops",
    ACTION_REPLAN_ORDER_LINEHAUL_TRANSIT = "LTL.Replan order linehaul transit",
    ACTION_USE_FREIGHT_GRIDS = "LTL.Order entry via grid",
    ACTION_DISPATCH_CREATE_GROUPS = "LTL.Create group in Dispatch",
    ACTION_LINEHAUL_CREATE_GROUPS = "LTL.Create group in Linehaul Routing",
    ACTION_DELIVERY_CREATE_GROUPS = "LTL.Create group in Delivery Routing",
    ACTION_UNCONFIRM_APPOINTMENTS = "Dispatch.Unconfirm appointments",
    ACTION_ANYWHERE_LOGIN = "Anywhere.Login",
    ACTION_ANYWHERE_DRIVER_MODE = "Anywhere.Disable Team Driver Mode",
    ACTION_TABLEROW_SERVICE_EDIT = "Anywhere.TablerowService edit",
    ACTION_TABLEROW_SERVICE_VIEW = "Anywhere.TablerowService view",
    ACTION_CANCEL_DISPATCH = "Dispatch.Unclear stops on in-progress or delivered movements",
    ACTION_ADD_UPDATE_AUTOMATCH_PROFILES = "Dispatch.Add/Update Auto Match profiles (Web only)",
    ACTION_CRM_UPDATE_ACTIONS_AFTER_COMPLETE = "CRM.Update prospect actions after completed",
    ACTION_CAN_UPDATE_RAPID_ALERT_DEFINITIONS = "Dispatch.Update any rapid alert definitions",
    ACTION_VIEW_PROTECTED_TEXT_MESSAGES = "SMS.View protected text messages",
    ACTION_VIEW_ROUTING_GUIDES = "Brokerage.Access all routing guide profiles",
    ACTION_GL_MULTICOMPANY_DRILLDOWN = "General Ledger.Search across companies",
    ACTION_ADVANCED_SEARCH = "System.Advanced search",
    ACTION_MULTISELECT_HOLD = "Multi-Select.On Hold",
    ACTION_MULTI_LOADBOARD = "Multi-Select.Post to Load Boards - Brokerage",
    ACTION_MULTI_RATE_CON = "Multi-Select.Send Rate Confirmation - Brokerage",
    ACTION_MULTI_TENDERS = "Multi-Select.Send Load Tenders - Brokerage",
    ACTION_MULTISELECT_REMOVE_CARRIER = "Multi-Select.Remove Carrier - Brokerage",
    ACTION_MULTI_UPDATE_FIELDS = "Multi-Select.Update Fields",
    ACTION_MULTISELECT_ASSIGN_CARRIER = "Multi-Select.Assign Carrier - Brokerage",
    ACTION_MULTISELECT_RATE_ORDERS = "Multi-Select.Rate Orders - Brokerage",
    ACTION_MULTISELECT_PREASSIGN = "Multi-Select.Preassign - Asset",
    ACTION_MULTISELECT_UNASSIGN = "Multi-Select.Unassign - Asset",
    ACTION_MULTISELECT_SEND_LOAD = "Multi-Select.Send Load - Asset",
    ACTION_MULTISELECT_CRM_COMPLETE = "Multi-Select.CRM - Complete Activities",
    ACTION_MULTISELECT_CRM_RESCHEDULE = "Multi-Select.CRM - Reschedule Activities",
}

export enum PermissionType {
    VIEW = 0,
    EDIT = 1,
    TABLE_ADD = 2,
    TABLE_EDIT = 3,
    TABLE_DELETE = 4
}

export class PermissionsUtil {
    static getDeniedItems(): any {
        return GeneralSettings.get()?.permissions?.denied;
    }

    static getDeniedActions(): any {
        return GeneralSettings.get()?.permissions?.denied?.Action;
    }

    static isUserDeniedAction(permission: ActionPermission): boolean {
        return PermissionsUtil.getDeniedActions()?.[permission] != null;
    }

    static isUserDeniedLayout(layoutName: string): boolean {
        return PermissionsUtil.isUserDeniedLayoutItem(layoutName, "Entire screen", PermissionType.VIEW);
    }

    static isUserDeniedLayoutItem(layoutName: string, itemName: string, type?: PermissionType): boolean {
        const deniedItem = PermissionsUtil.getDeniedItems()?.[layoutName]?.[itemName];
        return deniedItem != null && (type == null || deniedItem === type);
    }
}
